<template>
  <div class="form-group container__input">
    <slot name="label">
      <label v-if="label" :for="id" class="header__title">{{ label }}</label>
    </slot>

    <b-form-textarea
      v-if="inputType === 'textarea'"
      :id="id"
      :value="value"
      :placeholder="placeholder"
      :style="isInvalid && { border: '1px solid var(--danger)' }"
      :rows="rows"
      max-rows="6"
      class="input__description"
      @input="updateValue"
    />

    <div
      v-else-if="inputType === 'contenteditable'"
      v-safe-html="value"
      contenteditable="true"
      class="input__description border border-primary rounded p-3"
    />

    <b-input-group v-else-if="inputType === 'search-input'" class="input-group-seamless" size="md">
      <template>
        <b-input-group-text slot="prepend">
          <font-awesome-icon class="mx-auto" icon="search" />
        </b-input-group-text>
      </template>
      <b-form-input
        :id="id"
        :placeholder="placeholder"
        :value="value"
        @input="updateValue"
        @keyup.enter="handleEnter"
      />
    </b-input-group>

    <input
      v-else
      :id="id"
      class="form-control input__description"
      :style="isInvalid && { border: '1px solid var(--danger)' }"
      :type="inputType"
      :placeholder="placeholder"
      :value="value"
      @input="updateValue($event.target.value)"
    />

    <p v-show="isInvalid" class="mt-2 text__invalid-message" style="color: var(--danger)">
      <small>{{ invalidWarningText }}</small>
    </p>
  </div>
</template>

<script>
export default {
  name: 'BaseInput',

  props: {
    id: {
      type: String,
      default: 'inputText'
    },
    inputType: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Enter your text'
    },
    value: {
      type: String,
      default: ''
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    invalidWarningText: {
      type: String,
      default: ''
    },
    rows: {
      type: String,
      default: '3'
    }
  },

  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },

    handleEnter(event) {
      if (!event.shiftKey) {
        const { value } = this;

        this.updateValue(value.replace(/\n$/, ''));

        this.$emit('keyupEnter');
      }
    }
  }
};
</script>
